import qs from "qs";
var path = require("path");
var baseUrl = "/pos/v1/";
var key = "fits0800666811fits";
var headers = {
    'content-type': 'application/json',
    'x-api-key': key
};
export default {
    data() {
        return {}
    },
    methods: {
        apiGetTblinfo(query = "") { // 取得桌況
            var url = path.join(baseUrl, "tblinfo") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiOpenTbl(body) { // 開桌
            var url = path.join(baseUrl, "open-table");
            return this.$http.post(url, body, { headers: headers });
        },
        apiSendOrder(body) { // 傳送訂單
            var url = path.join(baseUrl, "send-order");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetBellData(query = "") { //取得服務鈴清單
            var url = path.join(baseUrl, "bell-data") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiCloseBell(body) { //關閉服務鈴
            var url = path.join(baseUrl, "close-bell");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetBKMenu(query = "") { //傳統菜單
            var url = path.join(baseUrl, "menus") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiPostImages(body) { //上傳圖片
            var url = path.join(baseUrl, "post-images");
            return this.$http.post(url, body, { headers: headers });
        },
        apiDeleteImage(body) { //刪除圖片
            var url = path.join(baseUrl, "delete-image");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetImages(query = "") { // 取得圖片清單
            var url = path.join(baseUrl, "images") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiUpdateExtgroup(body) { // 新增或更新 群組設定
            var url = path.join(baseUrl, "update-extgroup");
            return this.$http.post(url, body, { headers: headers });
        },
        apiDeleteExtgroup(body) { // 刪除群組設定
            var url = path.join(baseUrl, "delete-extgroup");
            return this.$http.post(url, body, { headers: headers });
        },
        apiUpdateExtitem(body) { // 新增或更新 餐點設定
            var url = path.join(baseUrl, "update-extitem", );
            return this.$http.post(url, body, { headers: headers });
        },
        apiUpdateExttype(body) { // 新增或更新 類別設定
            var url = path.join(baseUrl, "update-exttype");
            return this.$http.post(url, body, { headers: headers });
        },
        apiDeleteExttype(body) { // 刪除類別設定
            var url = path.join(baseUrl, "delete-exttype");
            return this.$http.post(url, body, { headers: headers });
        },
        apiMpoMenus(query = "") { //取得mpo菜單
            var url = path.join(baseUrl, "mpo-menus") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiMpoItemc(query = "") { //取得mpo菜品項目組合
            var url = path.join(baseUrl, "mpo-itemc") + "?" + qs.stringify(query);
            console.log(url, query);
            return this.$http.get(url, { headers: headers });
        },
        apiSaveExttype(body) {
            var url = path.join(baseUrl, "save-exttype");
            return this.$http.post(url, body, { headers: headers });
        },
        apiSaveExtitem(body) {
            var url = path.join(baseUrl, "save-extitem");
            return this.$http.post(url, body, { headers: headers });
        },
        apiSaveExtgroup(body) {
            var url = path.join(baseUrl, "save-extgroup");
            return this.$http.post(url, body, { headers: headers });
        },
        apiDownloadMenuItem(body) {
            var url = path.join(baseUrl, "download-menuitem");
            return this.$http.post(url, body, { headers: headers });
        },
        apiSaveConfig(body) {
            var url = path.join(baseUrl, "save-config");
            return this.$http.post(url, body, { headers: headers });
        },
        apiGetItemC(query = "") {
            var url = path.join(baseUrl, "mpo-itemc") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
        apiGetOCheck(query = "") {
            var url = path.join(baseUrl, "ocheck") + "?" + qs.stringify(query);
            return this.$http.get(url, { headers: headers });
        },
    },
};